import React from "react";
import Header from "@/components/Header/Header";
import Footer from "@/components/Footer/Footer";
import { useTranslation } from "@/translations/TranslationContext";
import "@/components/Services/Services.css";
import taxpreparation from "@/assets/services-taxpreparation.png";
import financialplanning from "@/assets/services-financialplanning.png";
import businessconsulting from "@/assets/services-businessconsulting.png";

const Services = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <Header />
      <div className="banner innerbanner mb150_75 banservices">
        <div className="container">
          <div className="inerban">
            <span className="chips">{t.services.banner.chips}</span>
            <h1>{t.services.banner.title}</h1>
            <p className="text24">
              {t.services.banner.subtitle}
            </p>
            <a className="btn btnbanner" href="/contact">
              {t.services.banner.button}
            </a>
          </div>
        </div>
      </div>

      <div className="container services mb150_75">
        <div className="row">
          <div className="col-lg-6">
            <span className="chips">{t.services.monthlyBookkeeping.chips}</span>
            <h2>{t.services.monthlyBookkeeping.title}</h2>
            <p className="text24">
              {t.services.monthlyBookkeeping.description}
            </p>
            <a
              className="btn btn-secondary"
              href="monthly-bookkeeping"
            >
              {t.services.monthlyBookkeeping.button}
            </a>
            <h3>{t.services.monthlyBookkeeping.benefits.title}</h3>
            <ul>
              {t.services.monthlyBookkeeping.benefits.points.map((point, index) => (
                <li key={index}>{point}</li>
              ))}
            </ul>
          </div>
          <div className="col-lg-6">
            <img src={businessconsulting} alt="businessconsulting" />
          </div>
        </div>
      </div>

      <div className="services bg mb150_75">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <img src={taxpreparation} alt="taxpreparation" />
            </div>
            <div className="col-lg-6">
              <span className="chips">{t.services.taxPreparation.chips}</span>
              <h2>{t.services.taxPreparation.title}</h2>
              <p className="text24">
                {t.services.taxPreparation.description}
              </p>
              <a className="btn btn-secondary" href="tax-preparation">
                {t.services.taxPreparation.button}
              </a>
              <h3>{t.services.taxPreparation.benefits.title}</h3>
              <ul>
                {t.services.taxPreparation.benefits.points.map((point, index) => (
                  <li key={index}>{point}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="container services mb150_75">
        <div className="row">
          <div className="col-lg-6">
            <span className="chips">{t.services.financialPlanning.chips}</span>
            <h2>{t.services.financialPlanning.title}</h2>
            <p className="text24">
              {t.services.financialPlanning.description}
            </p>
            <a className="btn btn-secondary" href="financial-planning">
              {t.services.financialPlanning.button}
            </a>
            <h3>{t.services.financialPlanning.benefits.title}</h3>
            <ul>
              {t.services.financialPlanning.benefits.points.map((point, index) => (
                <li key={index}>{point}</li>
              ))}
            </ul>
          </div>
          <div className="col-lg-6">
            <img src={financialplanning} alt="financialplanning" />
          </div>
        </div>
      </div>
      <div className="services bg mb150_75">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <img src={businessconsulting} alt="strategicsupport" />
            </div>
            <div className="col-lg-6">
              <span className="chips">{t.services.businessConsulting.chips}</span>
              <h2>{t.services.businessConsulting.title}</h2>
              <p className="text24">
                {t.services.businessConsulting.description}
              </p>
              <a className="btn btn-secondary" href="strategic-support">
                {t.services.businessConsulting.button}
              </a>
              <h3>{t.services.businessConsulting.benefits.title}</h3>
              <ul>
                {t.services.businessConsulting.benefits.points.map((point, index) => (
                  <li key={index}>{point}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Services;
